<template>
  <el-dialog
    class="dialog-container"
    width="600px"
    :visible.sync="dialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="cancel"
    title="驳回原因"
    center>
    <div class="flex flex-direction padding">
      <el-form class="ruleForm" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="auto">
        <el-form-item prop="refund_reason" label="驳回原因">
          <el-input type="textarea" v-model="ruleForm.refund_reason" rows="5" resize="none" placeholder="请输入">
          </el-input>
       </el-form-item>
      </el-form>
      <div class="dialog-operate flex align-center justify-center">
        <el-button class="btn min round" type="info" @click="cancel">取消</el-button>
        <el-button class="btn min round" type="primary" @click="submitForm('ruleForm')">
          确定
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>

import {approveProjectInfo} from "@/api/admin";

export default {
  name: "editOrgDialog",
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    id: {
        type: [String,Number],
      default: ''
    },
  },
  data() {
    return {
      options:[],
      ruleForm: {
        refund_reason: ''
      },
      rules: {
        refund_reason: [
          {required: true, message: '请输入', trigger: 'blur'}
        ],
      },
    }
  },
  created() {
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.save()
        }
      });
    },
    async save(){
      let _data = await approveProjectInfo(
        this.id,
        3,
        this.ruleForm.refund_reason
      );
      if(_data.code == 200) {
        this.$message.success(_data.message)
        this.$emit('watchState', false)
        this.clearContent()
      }else {
        this.$message.error(_data.message)
      }
    },

    clearContent() {
      this.$refs.ruleForm.resetFields()
    },
    cancel() {
      this.$emit('watchState', false)
    }
  },
  watch: {

  }
}
</script>

<style scoped lang="scss">

</style>
